export const MESSAGES = {
    SIGN_UP_SUCCESS: "Sign up successfull. Please Login!",
    SIGN_UP_FAILURE: "User already exist , Kindly Login !",
    LOGIN_SUCCESS: "Login successfull",
    LOGIN_FAILURE: "Incorrect email or password",
    INVALID_EMAIL: "Invalid email",
    EMAIL_VALIDATION: "Incorrect Email , must follow @gmail.com",
    PASSWORD_VALIDATION: "Password must be at least 6 characters",
    REQUIRED:"Required",
    SOMETHING_WENT_WRONG:"Something went Wrong",
    FIRST_NAME_VALIDATION:"First name must contain only letters",
    LAST_NAME_VALIDATION:"Last name must contain only letters",
    SESSION_TIMEOUT: "Your Session is timed out. Please Re-Log In",
  }; 
  
export const ROLES ={
  ADMIN: "ADMIN",
  EMPLOYEE: "EMPLOYEE",
}

export const STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  COMPLETED_BY_ADMIN: "completed_by_Admin",
}

export const STATUS_LABELS = {
  in_progress: "In Progress",
  completed: "Completed",
  completed_by_Admin: "Completed by Admin"
};

export const COMPANY_NAME = "Silverline Ops";

export const RESET_PAGINATION = {
  count: 0,
  offset: 0,
  limit: 15,
};

export const ASC = "asc";
export const DESC = "desc";
export const NO_DATA_AVAILABLE = "No data available!";